export default [{
  name: 'default',
  value: '"Graphik", sans-serif'
}, {
  name: 'alt',
  value: '"Tiempos", serif'
}];